import { REQUIRED_INDICATOR_CLASS_NAME } from '../../../../../components/baseV2';
import { FORTA_GRAY11, FORTA_GRAY12, FORTA_GRAY9 } from '../../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const DISCHARGE_EXPLAIN_OTHER_SX: SxProps<Theme> = { pl: 6 };

export const DISCHARGE_REASONS_CARD_SX: SystemStyleObject<Theme> = {
  p: '10px',
  borderRadius: '12px',
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
};

export const DISCHARGE_REASONS_CARD_DRAFTING_SX: SystemStyleObject<Theme> = {
  bgcolor: FORTA_GRAY12,
  [`& .${REQUIRED_INDICATOR_CLASS_NAME}`]: { bgcolor: FORTA_GRAY12 },
};

export const DISCHARGE_ADD_REASON_BUTTON_SX: SxProps<Theme> = {
  width: 150,
  height: 40,
  borderRadius: '8px',
  border: 'none',
  '&:hover': { border: 'none' },
  '&.Mui-disabled': { border: 'none' },
};

export const DISCHARGE_REASON_ROW_SX: SystemStyleObject<Theme> = {
  pl: '26px',
  pr: '6px',
  py: 0.5,
  minHeight: 48,
};

export const DISCHARGE_REASON_ROW_BORDER_SX: SystemStyleObject<Theme> = {
  border: `1px solid ${FORTA_GRAY11}`,
};

export const DISCHARGE_REASON_ROW_LABEL_SX: SxProps<Theme> = {
  fontFamily: 'DMSansMedium',
  fontSize: 14,
  color: FORTA_GRAY9,
};
